<template>
    <my-form
    v-model="form"
    table
    label-width="180px"
    @cancle="cancleHandler"
    @submit="submitHandler">
        <!-- <el-form-item
        class="table-full-row"
        label="是否已开始评标"
        >
            <th-state :readonly="readonly"></th-state>
           
        </el-form-item> -->
       
             <div class="tip">
                  <my-tag type="danger" >*未进入评标前可进行资格审查退回，已进入评标无法退回！</my-tag>
            </div>
       
        <template slot="btn" slot-scope="scope">
            <el-button
            :disabled=" readonly"
            @click="scope.submitHandler"
            type="danger"
            icon="el-icon-circle-check">
                退回
            </el-button>
            <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
        </template>
    </my-form>
</template>
                          
<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

import ThState from '../components/th-state'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { ThState },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {},

        shbj: '',
      
    }),
    computed: {
        readonly() {
            return (
                this.shbj
               
            );
        },
    },
    methods: {
        submitHandler() {
            ShowConfirm('确认退回？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzgsc.json`, this.data, (data, res) => {
                ShowMsg(res.msg);
                this.cancleHandler();
            });})
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzgscinit.json`, this.data, data => {
            this.shbj=data.result
        });
    }
}
</script>

<style scoped lang="scss">
.tip {
    margin: auto;
    margin-top:10px
}
</style>
